module.exports = __webpack_public_path__ + "static/media/complain1.a0b383d8.svg";